import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Input,
  Table,
  Form,
  Select,
  message,
  Spin,
  Modal,
  Row,
  Col,
  Tooltip,
  Space,
  Badge,
} from "antd";
import UIModal from "../../../Reusablecomponents/UIModal";
import { ReactComponent as Alert } from "../../../assets/images/alert1.svg";
import { ReactComponent as Filter } from "../../../assets/images/filter-svgrepo-com (1).svg";
import styled from "styled-components";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import GridBuilder from "../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../Reusablecomponents/ReusableDrawer";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import reset from "../../../assets/images/reset-svgrepo-com.svg";
import deleteicon from "../../../assets/images/delete-3-svgrepo-com.svg";
import edit from "../../../assets/images/edit-1-svgrepo-com.svg";
import { DatePicker } from "antd";
import { useNavigate } from "react-router-dom";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import ResetUser from "./ResetUser";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";

const Customstyle = styled.div`
  padding: 15px;
  .searchbar-style {
    width: 200px;
    border-radius: 12px;
  }
  .category-count-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 400;
    width: 108px;
    height: 19px;
    margin-left: 5px;
  }
  .btn {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .inactive-status {
    color: #f20000;
  }
  .active-status {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .status-indicator {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #78e38a;
    border: 2px solid #2c963d;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .status-indicator::before {
    content: "";
    width: 4px;
    height: 4px;
    background-color: #c2f7cb;
    border-radius: 50%;
  }
  .container_for_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .container_for_header_subtwo {
    display: flex;
    align-items: center;
  }
  @media (max-width: 481px) {
    .container_for_header {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      width: 100%;
    }
    .container_for_header_subtwo {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
`;

const StyledInput = styled(Input)`
  width: 312px !important;
  height: 39px;
  border-radius: 24px;
`;

function UserManagement() {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const officeList = useSelector((state) => state?.authTracking?.officeList);
  const roleList = useSelector((state) => state?.authTracking?.roleList);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState(null); // store full record, not just ID

  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const [hoveredRow, setHoveredRow] = useState(null);
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {}
  );
 
  const [userList, setUserList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isEdit, setIsEdit] = useState(false);
  const [iaView, setIsView] = useState(false);

  const [record, setRecord] = useState({});
  const [filterValues, setFilterValues] = useState({
    userid: "",
    username: "",
    email: "",
  });
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [popupMessage, setPopupMessage] = useState(null); // To store the message
  const [isPopupVisible, setIsPopupVisible] = useState(false); // To control popup visibility

  const [formData, setFormData] = useState({
    userid: "",
    firstname: "",
    lastname: "",
    email: "",
    office: "",
    dob: "",
    phone: "",
    idnumber: "",
    role: "",
    driverclass: "",
    vehicletype: "",
  });

  //Pagination
  const [usertotal, setUserTotal] = useState(0);
  const [userCurrentPage, setUserCurrentPage] = useState(1);
  const [userpageSize, setUserPageSize] = useState(10);
  const [customFields, setCustomFields] = useState([]);
  const userPageChange = (page, pageSize) => {
    setUserCurrentPage(page);
    setUserPageSize(pageSize);
  };

  const userPageSizeChange = (value) => {
    setUserPageSize(value);
    setUserCurrentPage(1);
  };
  const [AllCustomeData, SetAllCustomeData] = useState([]);

  const GetAllCustomeData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=User`
      );

      SetAllCustomeData(data);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchUserLiat = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `user/getAll?limit=${userpageSize}&page=${userCurrentPage}&userId=${filterValues?.userid}&fullNm=${filterValues?.username}&email=${filterValues?.email}`,
        {}
      );
      // Enrich user list with custom fields
      const newData =
        data?.data?.map((userItem) => {
          const enrichedItem = { ...userItem };

          // Match fields by REFID === uid (adjust if your user ID is different)
          const matchedFields =
            AllCustomeData?.filter((field) => field.REFID === userItem.UID) ||
            [];

          matchedFields.forEach((field) => {
            enrichedItem[field.CFID] = field.VALUE;
          });

          return enrichedItem;
        }) || [];
      setUserList(newData);
      setUserTotal(data?.totalRecords || newData.length || 0);
    } catch (error) {
      console.error("Error fetching user list", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userList && userList.length > 0) {
      fetchUserLiat();
    }
  }, []);

  useEffect(() => {
    fetchUserLiat();
  }, [userpageSize, userCurrentPage, filterValues]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const showDrawer = () => {
    setIsEdit(false);
    setFormData({
      userid: "",
      firstname: "",
      lastname: "",
      email: "",
      office: "",
      dob: "",
      phone: "",
      idnumber: "",
      role: "",
      driverclass: "",
      vehicletype: "",
    });
    setOpen(true);
  };

  const editUser = (record) => {
    setIsEdit(true);
    setFormData(record);
    setOpen(true);
  };
  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setFormData({});
    setIsEdit(false);
  };
  //Custome Field api calling Function

  const loadCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "User",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCustomFields();
    GetAllCustomeData();
  }, []);


  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const createAllowed = useMemo(() => hasPermission("USR", "C"), [
    reduxPermissions,
  ]);
  const updateAllowed = useMemo(() => hasPermission("USR", "U"), [
    reduxPermissions,
  ]);
  const deleteAllowed = useMemo(() => hasPermission("USR", "D"), [
    reduxPermissions,
  ]);
  const getFieldType = (type) => {
    const typeMap = {
      1: "select", // DropDown
      2: "text", // TextBox
      3: "checkbox", // CheckBox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };

  const dynamicCustomColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) return [];

    return customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME, // ← match raw field name
      key: field.CFID,
      sorter: false,
      render: (text) => text || "-",
    }));
  }, [customFields]);
  //custome data creat api call functionality
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (uid) => {
    try {
      const customDataList = customFields
        .map((field) => {
          const fieldName = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
          const value = formData?.[fieldName];
          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: uid,
              Value: value,
            };
          }
          return null;
        })
        .filter(Boolean);

      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateCustomeData(data);
    } catch (error) {
      setCreateCustomeData([]);
      console.error("Error creating custom fields:", error);
    }
  };
  //Update custom data api call functionality
  const CustomeDataUpdate = async (uid) => {
    setLoading(true);
    try {
      // Loop through all custom fields
      for (const field of customFields) {
        const fieldName = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
        const value = formData?.[fieldName];

        // Find the existing custom data for this field and user entry
        const existing = AllCustomeData?.find(
          (item) => item.REFID === uid && item.CFID === field.CFID
        );

        // Only update if value is present and there is an existing record
        if (value !== undefined && value !== "" && existing) {
          const payload = {
            CfId: field.CFID,
            RefId: uid,
            Value: value,
            DataId: existing.DATAID,
          };

          await CALL_API("PATCH", "mastertable/updateCustomData", payload);
        }
      }
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (uid) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: uid, // <-- Use refId here
          RefTab: "User",
          McId: userInfo?.MCID,
        }
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleReset = async (record) => {
    try {
      setLoading(true);
      const payload = {
        UID: record?.UID,
        USERID: record?.USERID,
        FIRSTNM: record?.FIRSTNM,
        LASTNM: record?.LASTNM,
        EMAIL: record?.EMAIL,
        ZONE: 2,
        MNGID: null,
        LOCKED: record?.LOCKED === false ? 0 : 1,
        SYSADM: 0,
        CRBY: 2,
        OFFID: record?.OFFID,
        CHATCONID: 0,
        PHONE: record?.CONTACTNO,
        CONTACTNO: record?.CONTACTNO,
        DASHWIDGETS: record?.DASHWIDGETS,
        ACTION: "RESETPWD",
      };

      const { data } = await CALL_API("POST", `user/manageUser`, payload);
      message.success("User Reset Successfully");
      handleCancel();
      fetchUserLiat(true);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };
  const handleDelete = async (record) => {
    try {
      setLoading(true);
      const payload = {
        UID: record?.UID,
        USERID: record?.userid,
        FIRSTNM: record?.firstname,
        LASTNM: record?.lastname,
        EMAIL: record?.email,
        PWHASH: "",
        ZONE: 2,
        MNGID: null,
        LOCKED: record?.LOCKED === false ? 0 : 1,
        SYSADM: 0,
        CRBY: 2,
        OFFID: record?.office,
        CHATCONID: 0,
        PHONE: record?.phone,
        CONTACTNO: record?.phone,
        DASHWIDGETS: record?.DASHWIDGETS,
        ACTION: "DELETE",
      };

      const { data } = await CALL_API("POST", `user/manageUser`, payload);
      const refId = record?.UID || record?.userid;

      if (refId) {
        await CustomeDataDelete(refId);
      } else {
        console.warn("Missing RefId for custom delete");
      }
      if (message.success) {
        message.success("User Deleted Successfully");
        setIsView(false);
      } else {
      }

      handleCancel();
      fetchUserLiat();
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const fetchDriverList = async () => {
    const { data } = await CALL_API("POST", "common/getDriver", {
      mcId: userInfo.MCID,
    });
  };

  const handleSubmitForm = async (values) => {
    try {
      setLoading(true);
      const payload = {
        UID: 0,
        USERID: formData?.userid,
        FIRSTNM: formData?.firstname,
        LASTNM: formData?.lastname,
        EMAIL: formData?.email,
        PWHASH: "",
        ZONE: 2,
        MNGID: null,
        LOCKED: 0,
        SYSADM: 0,
        CRBY: userInfo?.UID,
        OFFID: formData?.office,
        CHATCONID: 0,
        PHONE: formData?.phone,
        CONTACTNO: formData?.phone,
        DASHWIDGETS: "",
        ACTION: "INSERT",
        Roles: [
          {
            RoleID: formData.role || 0,
          },
        ],
      };
      const updatepayload = {
        UID: formData?.UID,
        USERID: formData?.userid,
        FIRSTNM: formData?.firstname,
        LASTNM: formData?.lastname,
        EMAIL: formData?.email,
        PWHASH: "",
        ZONE: 2,
        MNGID: null,
        LOCKED: formData?.LOCKED === false ? 0 : 1,
        SYSADM: formData?.UID === 2 ? 1 : 0,
        CRBY: 2,
        OFFID: formData?.office,
        CHATCONID: 0,
        PHONE: formData?.phone,
        CONTACTNO: formData?.phone,
        DASHWIDGETS: formData?.DASHWIDGETS,
        ACTION: "UPDATE",
        Roles: [
          {
            RoleID: formData.role || 0,
          },
        ],
      };
      const {
        data,
        ResponseCode,
        message: apiMessage,
      } = await CALL_API(
        "POST",
        isEdit ? "user/manageUser" : `user/manageUser`,
        isEdit ? updatepayload : payload
      );
      fetchUserLiat();
      const UID = isEdit
        ? formData?.UID
        : data?.UID || data?.uid || data?.result?.UID;
      if (UID) {
        if (!isEdit) {
          await CustomeDataCreate(UID, values);
        } else {
          await CustomeDataUpdate(UID, values);
        }
      }

      // Handle known validation errors
      if (ResponseCode === 400) {
        const errorMessage = data;

        if (errorMessage.includes("already")) {
          setPopupMessage(errorMessage);
          setIsPopupVisible(true);
          setLoading(false);
          return; // Exit early
        }

        // Handle other 400 errors
        message.error(
          errorMessage || "Bad request, please check your parameters."
        );
        setLoading(false);
        return; // Exit early
      }

      message.success(
        isEdit ? "User Updated Successfully" : "User Created Successfully"
      );
      handleCancel();
      fetchDriverList();
      GetAllCustomeData();
      fetchUserLiat();
      setLoading(false);
      setIsView(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const columns = [
    {
      title: "User ID",
      dataIndex: "USERID",
      key: "USERID",
      width: "7%",
    },
    {
      title: "User Name",
      dataIndex: "FULLNM",
      key: "FULLNM",
      width: "10%",
    },
    {
      title: "Email",
      dataIndex: "EMAIL",
      key: "EMAIL",
      width: "17%",
    },
    {
      title: "Office",
      dataIndex: "OFFNM",
      key: "OFFNM",
      width: "15%",
      // render: (text) => {
      //   return officeList?.find((item) => item?.OFFID === text)?.OFFNM;
      // },
    },
    {
      title: "Phone",
      dataIndex: "CONTACTNO",
      key: "CONTACTNO",
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "LOCKED",
      key: "LOCKED",
      width: "15%",
      render: (text) =>
        text === true ? (
          <span className="inactive-status">In Active</span>
        ) : (
          <span className="active-status">
            <span className="status-indicator"></span>
            Active
          </span>
        ),
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   width: "35%",
    //   render: (_, record) =>
    //     hoveredRow === record.key ? (
    //       <div className="d-flex gap-3"
    //       style={{ display: "flex", gap: "6px" }}
    //       >
    //         <img
    //           src={reset}
    //           alt="Reset Icon"
    //           style={{ width: 22, height: 22, cursor: "pointer" }}
    //           onClick={(e) => {
    //             e.stopPropagation();
    //             handleReset(record);
    //           }}
    //         />
    //         <img
    //           src={edit}
    //           alt="Edit Icon"
    //           onClick={(e) => {
    //             e.stopPropagation();
    //             setFormData({
    //               UID: record?.UID,
    //               userid: record?.USERID,
    //               firstname: record?.FIRSTNM,
    //               lastname: record?.LASTNM,
    //               email: record?.EMAIL,
    //               PWHASH: record?.PWHASH,
    //               ZONE: record?.ZONE,
    //               MNGID: record?.MNGID,
    //               LOCKED: record?.LOCKED,
    //               SYSADM: record?.SYSADM,
    //               CRBY: record?.CRBY,
    //               office: record?.OFFID,
    //               CHATCONID: record?.CHATCONID,
    //               phone: record?.CONTACTNO, // Assuming CONTACTNO is used for phone
    //               DASHWIDGETS: record?.DASHWIDGETS,
    //               role: record?.ROLEID,
    //             });
    //             setIsEdit(true);
    //             setOpen(true);
    //           }}
    //           style={{ width: 22, height: 22, cursor: "pointer" }}
    //         />
    //         <img
    //           src={deleteicon}
    //           alt="Delete Icon"
    //           style={{ width: 22, height: 22, cursor: "pointer" }}
    //           onClick={(e) => {
    //             e?.stopPropagation();
    //             setDeleteRecord(record); // Store the full user record
    //             setIsDeleteModalVisible(true);
    //           }}
    //         />
    //       </div>
    //     ) : null,
    // },
  ];

  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  const combinedColumns = useMemo(() => {
    const staticCols = [...columns];

    if (!customFields || customFields.length === 0) return staticCols;

    const dynamicCols = customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME,
      key: field.CFID,
      sorter: false,
      render: (_, record) => record?.[field.CFID] ?? "-",
    }));

    return [...staticCols, ...dynamicCols];
  }, [columns, customFields]);

  const AddEditForm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      [
        {
          id: 1,
          label: "User ID",
          type: "text",
          name: "userid",
          placeholder: "Enter User ID",
          maxLength: 50,
          style: { width: "259px", height: "36px", gap: "10px" },
          validationRules: [{ required: true, message: "User ID is required" }],
        },
        {
          id: 2,
          label: "First Name",
          type: "text",
          name: "firstname",
          placeholder: "Enter First Name",
          maxLength: 50,
          validationRules: [
            { required: true, message: "First Name is required" },
          ],
        },
        {
          id: 3,
          label: "Last Name",
          type: "text",
          name: "lastname",
          placeholder: "Enter Last Name",
          maxLength: 50,
          style: { width: "259px", height: "36px", gap: "10px" },
          validationRules: [
            { required: true, message: "Last Name is required" },
          ],
        },
        {
          id: 4,
          label: "Email",
          type: "email",
          name: "email",
          placeholder: "Enter your email",
          maxLength: 50,
          style: { width: "259px", height: "36px", gap: "10px" },
          validationRules: [
            { required: true, message: "Email is required" },
            {
              pattern: /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: "Please enter a valid email",
            },
          ],
        },
      ],
      [
        {
          id: 5,
          label: "Office",
          type: "selectwithvalue",
          name: "office",
          options: officeList?.map((item) => ({
            value: item.OFFID,
            label: item.OFFNM,
          })),
          validationRules: [{ required: true, message: "Office is required" }],
        },
        // {
        //   id: 6,
        //   label: "D.O.B",
        //   type: "date",
        //   name: "dob",
        //   value: formData.dob,
        //   onChange: handleChange("dob"),
        //   component: (
        //     <DatePicker
        //       style={{ width: "100%" }}
        //       onChange={(date) => handleChange("dob")(date)}
        //     />
        //   ),
        // },
        {
          id: 7,
          label: "Phone",
          type: "text",
          name: "phone",
          placeholder: "Enter Phone Number",
          style: { width: "259px", height: "36px", gap: "10px" },
          validationRules: [
            { required: true, message: "Phone number is required" },
          ],
        },
        // {
        //   id: 8,
        //   label: "ID Number",
        //   type: "text",
        //   name: "idnumber",
        //   placeholder: "Enter ID Number",
        //   style: { width: "259px", height: "36px", gap: "10px" },
        // },
        {
          id: 9,
          label: "Role",
          type: "selectwithvalue",
          name: "role",
          options: roleList?.map((item) => ({
            value: item?.ROLEID,
            label: item?.ROLENAME,
          })),
          validationRules: [
            { required: true, message: "Role is required" },
          ],
        },
        {},
      ],
      [
        // {
        //   id: 10,
        //   label: (
        //     <span>
        //       Driver Class <span style={{ color: "red" }}>*</span>
        //     </span>
        //   ),
        //   type: "select",
        //   name: "driverclass",
        //   value: formData.driverclass,
        //   onChange: (value) => handleSelectChange("driverclass", value),
        //   options: driverClassOptions,
        //   component: (
        //     <Select
        //       placeholder="Select Driver Class"
        //       value={formData.driverclass}
        //       onChange={(value) => handleSelectChange("driverclass", value)}
        //       style={{ width: "259px", height: "36px", gap: "10px" }}
        //       validationRules={[
        //         { required: true, message: "Driver Class is required" },
        //       ]}
        //     >
        //       {driverClassOptions.map((option) => (
        //         <Select.Option key={option} value={option}>
        //           {option}
        //         </Select.Option>
        //       ))}
        //     </Select>
        //   ),
        // },
        // {
        //   id: 11,
        //   label: (
        //     <span>
        //       Vehicle Type <span style={{ color: "red" }}>*</span>
        //     </span>
        //   ),
        //   type: "select",
        //   name: "vehicletype",
        //   value: formData.vehicletype,
        //   onChange: (value) => handleSelectChange("vehicletype", value),
        //   options: vehicleTypeOptions,
        //   component: (
        //     <Select
        //       placeholder="Select Vehicle Type"
        //       value={formData.vehicletype}
        //       onChange={(value) => handleSelectChange("vehicletype", value)}
        //       style={{ width: "259px", height: "36px", gap: "10px" }}
        //       //   validationRules={[{ required: true, message: "Vehicle Type is required" }]}
        //       onBlur={() => {
        //         if (!formData.vehicletype) {
        //           alert("Vehicle Type is required");
        //         }
        //       }}
        //     >
        //       {vehicleTypeOptions.map((option) => (
        //         <Select.Option key={option} value={option}>
        //           {option}
        //         </Select.Option>
        //       ))}
        //     </Select>
        //   ),
        // },
        // {
        //   id: 12,
        //   label: "",
        //   type: "",
        //   name: "",
        //   value: formData.dob,
        //   onChange: handleChange(""),
        //   component: (
        //     <DatePicker
        //       style={{ width: "100%" }}
        //       onChange={(date) => handleChange("")(date)}
        //     />
        //   ),
        // },
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0)
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);

  return (
    <Customstyle>
      {/*     
      <div className="d-flex justify-content-between align-items-center    container_for_header">
        <div className="total">{usertotal} Users </div>
        <div className="d-flex align-items-center m-0 p-0 gap-4     container_for_header_subtwo">
          <div>
            <StyledInput
              prefix={
                <SearchOutlined
                  style={{ color: "#636980", cursor: "default" }}
                />
              }
              className="searchbar-style"
            />
          </div>
          <ButtonFilled type="primary" onClick={showDrawer}>
            + Create
          </ButtonFilled>
        </div>
      </div> */}
      {!iaView ? (
        <>
          {" "}
          <div className="container_for_header">
            <div className="total">{usertotal} Users </div>
            <div className="container_for_header_subtwo">
              <div>
                <Button
                  className="rounded-circle border"
                  onClick={() => setFilterModalOpen(true)}
                >
                  <Space size="middle">
                    <Badge size="small" count={filterCount}>
                      <Filter />{" "}
                    </Badge>
                  </Space>
                </Button>
              </div>
              <Tooltip title={!createAllowed ? "No permission" : ""}>
                <span>
                  <ButtonFilled
                    type="primary"
                    onClick={showDrawer}
                    disabled={!createAllowed}
                  >
                    + Create
                  </ButtonFilled>
                </span>
              </Tooltip>
            </div>
          </div>
          <Spin spinning={loading}>
            {userList.length > 0 && (
              <StyledTable
                className="mt-4"
                dataSource={userList}
                columns={combinedColumns}
                pagination={false}
                style={{
                  cursor: "pointer",
                }}
                onRow={(record) => ({
                  onClick: () => {
                    setIsView(true);
                    setRecord(record);
                  },
                  onMouseEnter: () => setHoveredRow(record.key),
                  onMouseLeave: () => setHoveredRow(null),
                })}
              />
            )}
            <ReusablePagination
              pageSize={userpageSize}
              handlePageSizeChange={userPageSizeChange}
              currentPage={userCurrentPage}
              total={usertotal}
              handlePageChange={userPageChange}
            />
          </Spin>
        </>
      ) : (
        <ResetUser
          record={record}
          setIsView={setIsView}
          setFormData={setFormData}
          setIsEdit={setIsEdit}
          handleDelete={handleDelete}
          handleReset={handleReset}
          setOpen={setOpen}
          iaView={iaView}
          dloading={loading}
          fetchUserLiat={fetchUserLiat}
        />
      )}
      <ReusableDrawer
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            {isEdit ? "Modifying User" : "Creating User"}
          </div>
        }
        open={open}
        setOpen={setOpen}
        onOk={handleSubmitForm}
        onClose={handleCancel}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={handleCancel}
            >
              Cancel
            </Buttontransparent>
            <Tooltip
              title={isEdit ? (!updateAllowed ? "No permission" : "") : (!createAllowed ? "No permission" : "")}
            >
              <span>
                <ButtonFilled
                  loading={loading}
                  onClick={() => form.submit()}
                  disabled={isEdit ? !updateAllowed : !createAllowed}
                >
                  {isEdit ? "Update" : "Create"}
                </ButtonFilled>
              </span>
            </Tooltip>
          </div>,
        ]}
        children={
          <GridBuilder
            grid={formData}
            formStructureJson={AddEditForm}
            handleChange={handleChange}
            formSubmit={handleSubmitForm}
            initialValues={formData}
            form={form}
            handleSelectChange={handleSelectChange}
          />
        }
      />
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteRecord(null);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this User?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <Tooltip title={!deleteAllowed ? "No permission" : ""}>
              <span>
                <ButtonFilled
                  onClick={() => {
                    if (!deleteAllowed) return;
                    handleDelete(deleteRecord); // Use full record
                    setIsDeleteModalVisible(false);
                    setDeleteRecord(null);
                  }}
                  disabled={!deleteAllowed}
                >
                  Yes
                </ButtonFilled>
              </span>
            </Tooltip>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteRecord(null);
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              setUserCurrentPage(1); // Reset to first page
              setFilterValues({ userid: "", username: "", email: "" }); // Reset the state
              filterform?.setFieldsValue({
                userid: "",
                username: "",
                email: "",
              }); // Reset the form fields
              setFilterCount(0);
              setFilterModalOpen(false);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Form
          form={filterform}
          layout="vertical"
          onValuesChange={(value, allvalues) => {
            const count = Object.values(allvalues).filter(
              (val) =>
                val !== undefined && val !== null && String(val).trim() !== ""
            ).length;

            setFilterCount(count);
            setUserCurrentPage(1); // Reset to first page
            setFilterValues(allvalues);
          }}
          initialValues={filterValues}
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="User ID" name="userid">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="User Name" name="username">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Email" name="email">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Alert />
            <span>Information</span>
          </div>
        }
        visible={isPopupVisible}
        onOk={() => setIsPopupVisible(false)} // Close the popup when "OK" is clicked
        onCancel={() => setIsPopupVisible(false)} // Allow closing with the "X" button
        footer={[
          <ButtonFilled key="ok" onClick={() => setIsPopupVisible(false)}>
            OK
          </ButtonFilled>,
        ]}
      >
        <p style={{ fontSize: "15px" }}>{popupMessage}</p>
      </Modal>
    </Customstyle>
  );
}

export default UserManagement;
